import React from 'react';
import { connect } from 'react-redux';

import QuestionHOC from './QuestionHOC';

function HPI({ notePreview, item, index }) {
  return <QuestionHOC item={item} index={index}>
    <div className="row">
      <div className="col">
        <p className="mt-3" style={{ fontSize: 18, fontWeight: 'bold' }}>History of Present Illness</p>
        <p>{notePreview || "Jane Doe is a 44 year old female post routine follow up. Since the last visit, patient's condition is remained the same. Patient is experiencing no progressive weakness or worsening arm or leg pain. Severity of patient\'s pain is 3. Patient reports that the following treatments have helped: pain medications, and other. Patient reports that the following treatments have not helped: none. . This test was completed at: i haven't had any tests . The following studies are yet to be completed: none. Further concerns or questions include: I'm struggling with going up and down stairs. On my last appointment I explained how I'm struggling with going up and down stairs. I asked for physical therapy."}</p>
      </div>
    </div>
  </QuestionHOC>
}

const mapStateToProps = state => {
  return {
    notePreview: state.questionnaire.notePreview
  }
}

export default connect(mapStateToProps)(HPI);